/**
 * Single source of truth for opening the attendance screen from any slot-list
 * surface (instructor's /my-teaching-plan, admin's /schedules-templates/:id
 * Conducted View, and any future entry point).
 *
 * `instructorId` + `instructorName` are optional but strongly recommended:
 * the admin flow requires them (the /attendance-node page validates the
 * instructor→batch mapping against the URL params, not against the logged-in
 * user). For the instructor's own /my-teaching-plan page they're harmless
 * duplicates of the session user, so passing them always is safe.
 */
export function openAttendanceForBatches(
  batchIds: number[],
  templateSlotId?: number,
  instructorId?: number,
  instructorName?: string,
): void {
  if (!batchIds.length) return;
  const params = new URLSearchParams();
  if (templateSlotId) params.set('templateSlotId', String(templateSlotId));
  if (instructorId) params.set('instructorId', String(instructorId));
  if (instructorName) params.set('instructorName', instructorName);
  const qs = params.toString();
  const url = `/attendance-node/batches/${batchIds.join(',')}${qs ? `?${qs}` : ''}`;
  window.open(url, '_blank');
}
